import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const RatingReviewTranslations = wrapTranslationsSchema({
	name: 'RatingReviewTranslations',
	title: 'Rating/Review Translations',
	sanityId: 'ratingReview',
	fields: {
		rateOrReview: 'Rate/Review',
		countOne: '{count} rating',
		countOther: '{count} ratings',
		title: 'How was your Experience?',
		description: 'Provide a Rating',
		submitSuccessTitle: 'Thank you!',
		seeReviews: 'See Reviews',
		submitSuccessMessage:
			'Your feedback has been submitted. Thank you for sharing your feedback, your input helps us elevate the quality of our store and deliver a better experience for you!',
		deleteSuccessMessage: 'Your rating has been successfully deleted.',
		delete: 'Delete',
		deleteQuestion: 'Are you sure you want to delete?',
		deleteIrreversibleWarning:
			'Deleting your rating or review is not reversible. Are you sure you want to delete it?',
		deleteRatingAndReview: 'Delete Rating and Review',
		optional: 'Optional',
		characters: 'Characters',
		reviewDescription: 'Give us a review of your experience',
		reviewSubmitSuccessMessage: 'Your review has been successfully submitted.',
		reviewDeleteSuccessMessage: 'Your review has been successfully deleted.',
		reviewPlaceholder: 'Enter any additional comments...',
		reviewReviewedOn: 'Reviewed on',
		reviewNoReviews: 'No reviews have been submitted for this item.',
	},
});
